<template>
	<svg width="15px" height="27px" viewBox="0 0 15 27" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
		<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
			<path
				d="M1.02687591,0.886669429 C1.30141902,0.612069101 1.74659313,0.612069101 2.02119345,0.886669429 L14.3874207,13.2527822 C14.662021,13.5274398 14.662021,13.9726139 14.3874207,14.2472142 L2.02119345,26.6133842 C1.74659313,26.8879273 1.30141902,26.8879273 1.02687591,26.6133842 L0.612543553,26.1991091 C0.337943225,25.9245088 0.337943225,25.4792774 0.612543553,25.2047343 L12.0671938,13.7500268 L0.612543553,2.29531933 C0.337943225,2.020719 0.337943225,1.57548767 0.612543553,1.30094456 L1.02687591,0.886669429 Z"
				id="c"
				fill-rule="nonzero"
				:style="{
					width: width,
					fill: colour
				}"
			></path>
		</g>
	</svg>
</template>

<script>
import Mixin from './Mixin';

export default {
  mixins: [Mixin],
};
</script>
